module.exports = __webpack_public_path__ + "media/src/assets/Images/ArrowLeftBig-7596052fd68d70900bc89aa218fc7309.svg";